import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import psHttp from '@patsnap/common-ps-http';
import {
    createCreditsChargeSdk,
    type CreditsChargeLocale,
} from '@patsnap/credits-charge';
import { EUREKA_SERVICE_URI } from '@telecom/shared/domain-config/config';
import { isUserLogin } from '@telecom/shared/startup/user-auth';
import { getIsOversea } from '@telecom/shared/utils/environment';

const CREDITS_CHARGE_LOCALES: readonly CreditsChargeLocale[] = ['cn', 'en', 'jp', 'tw'];

/**
 * 页面挂载完成后检查并领取新用户积分充值。
 */
export function useCreditsCharge(): void {
    const { locale: currentLocale } = useI18n();

    onMounted(async () => {
        try {
            const isLogin = await isUserLogin();
            if (!isLogin || !getIsOversea()) return;

            const locale = CREDITS_CHARGE_LOCALES.includes(currentLocale.value as CreditsChargeLocale)
                ? currentLocale.value as CreditsChargeLocale
                : 'en';
            const creditsChargeSdk = createCreditsChargeSdk({
                baseURL: EUREKA_SERVICE_URI,
                http: psHttp,
                locale,
            });
            await creditsChargeSdk.checkAndClaim();
        } catch (error) {
            console.warn('Credits charge initialization failed:', error);
        }
    });
}
